export default __webpack_public_path__ + "static/media/Deployment_icon.daf881dc.gif";